export class MultipleInverter {
    invID: string;
    count: number;

    constructor(invID: string, count: number) {
        this.invID = invID;
        this.count = count;
    }
}
